export default class Iterator {
    /**
     * The Iterator class is an interface for the iterators used in several collections
     * @constructor
     * @returns {undefined}
     */
    constructor() { };

    start() { };

    /**
     * Retrieves the current item and moves the iterator to the next item in the sequence.
     * @returns {*}
     */
    next() {
        return null;
    };

    /**
     * Checks if the next item exists.
     * @returns {Boolean}
     */
    hasNext() {
        return false;
    };

    /**
     * Grants access to the current item being referenced by the iterator.
     * @returns {unresolved}
     */
    getData() {
        return null;
    };

    setData() { };
}